export const oneStepInstallationModalDataHooks = {
  MODAL: 'one-step-installation-modal',
} as const;

export const MODAL_DATA_HOOK = oneStepInstallationModalDataHooks.MODAL;
